import { render, staticRenderFns } from "./ReturnGoodsTwo.vue?vue&type=template&id=fee5738e&"
import script from "./ReturnGoodsTwo.vue?vue&type=script&lang=ts&"
export * from "./ReturnGoodsTwo.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnGoodsTwo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports